/**
 * Substitutes section: a small label and two compact per-team lists (kit + abbr header, then
 * number / name rows; players who came on get a mint up-arrow).
 */

import React from 'react';
import { Text, View } from 'react-native';
import { ArrowUp } from 'lucide-react-native';
import { SoccerKit } from '../../ui/SoccerKit';
import { useTheme } from '../../../src/theme/useTheme';
import type { MatchHubLineupPlayer, MatchHubTeamSide } from '../../../src/match/types/matchHub.types';
import type { MatchHubLineupsStyles } from './MatchHubLineupsPanel.styles';

function SubsList({
  team,
  subs,
  styles,
  onColor,
}: {
  team: MatchHubTeamSide;
  subs: MatchHubLineupPlayer[];
  styles: MatchHubLineupsStyles;
  onColor: string;
}) {
  return (
    <View style={styles.subsCard}>
      <View style={styles.subsHead}>
        <SoccerKit primary={team.kit.primary} secondary={team.kit.secondary} type={team.kit.type} size={16} />
        <Text style={styles.subsAbbr}>{team.shortName}</Text>
      </View>
      {subs.map((s) => {
        const cameOn = (s.markers ?? []).includes('sub_on');
        return (
          <View key={s.id} style={styles.subRow}>
            <Text style={styles.subNum}>{s.number}</Text>
            <Text style={[styles.subName, cameOn ? styles.subNameOn : styles.subNameOff]} numberOfLines={1}>
              {s.name}
            </Text>
            {cameOn ? <ArrowUp size={12} color={onColor} strokeWidth={3} /> : null}
          </View>
        );
      })}
    </View>
  );
}

export interface MatchHubLineupsSubsProps {
  home: MatchHubTeamSide;
  away: MatchHubTeamSide;
  homeSubs: MatchHubLineupPlayer[];
  awaySubs: MatchHubLineupPlayer[];
  styles: MatchHubLineupsStyles;
}

export const MatchHubLineupsSubs: React.FC<MatchHubLineupsSubsProps> = ({
  home,
  away,
  homeSubs,
  awaySubs,
  styles,
}) => {
  const theme = useTheme();
  return (
    <View style={styles.subsSection}>
      <Text style={styles.subsSectionTitle}>SUBSTITUTES</Text>
      <View style={styles.subsRow}>
        <SubsList team={home} subs={homeSubs} styles={styles} onColor={theme.success} />
        <SubsList team={away} subs={awaySubs} styles={styles} onColor={theme.success} />
      </View>
    </View>
  );
};
